export default {
  abi: [
    {
      "inputs": [
        {
          "internalType": "string",
          "name": "name_",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "symbol_",
          "type": "string"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "decimals",
          "type": "uint256"
        },
        {
          "internalType": "address",
          "name": "admin",
          "type": "address"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Approval",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "previousOwner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "OwnershipTransferred",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Transfer",
      "type": "event"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        }
      ],
      "name": "allowance",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "approve",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "balanceOf",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "decimals",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "subtractedValue",
          "type": "uint256"
        }
      ],
      "name": "decreaseAllowance",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "addedValue",
          "type": "uint256"
        }
      ],
      "name": "increaseAllowance",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "mint",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "name",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "owner",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "renounceOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "symbol",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "transfer",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "transferFrom",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "transferOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ],
  bytecode: '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'
}



// WEBPACK FOOTER //
// ./src/erc20/Mintable.js